var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20.026,
    viewBox: "0 0 18 20.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1237 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-notifications-outline",
    "data-name": "Icon ionic-ios-notifications-outline",
    transform: "translate(1230.225 17.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M20.37,28.336a.911.911,0,0,0-.893.717,1.762,1.762,0,0,1-.352.766,1.329,1.329,0,0,1-1.132.415,1.351,1.351,0,0,1-1.132-.415,1.762,1.762,0,0,1-.352-.766.911.911,0,0,0-.893-.717h0a.917.917,0,0,0-.893,1.118,3.142,3.142,0,0,0,3.27,2.609,3.136,3.136,0,0,0,3.27-2.609.92.92,0,0,0-.893-1.118Z",
    transform: "translate(-3.23 -8.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M22.574,17.444c-.771-.926-2.287-1.469-2.287-5.614,0-4.255-2.062-5.966-3.984-6.376-.18-.041-.31-.1-.31-.269V5.052a1.174,1.174,0,0,0-1.2-1.122h-.03a1.174,1.174,0,0,0-1.2,1.122v.132c0,.169-.13.228-.31.269-1.927.415-3.984,2.121-3.984,6.376,0,4.146-1.517,4.684-2.287,5.614a.9.9,0,0,0,.8,1.45h14.02A.9.9,0,0,0,22.574,17.444Zm-1.952.265H8.95a.2.2,0,0,1-.165-.333,5.489,5.489,0,0,0,1.051-1.523,9.516,9.516,0,0,0,.716-4.023A6.515,6.515,0,0,1,11.6,7.871a3.234,3.234,0,0,1,1.937-1.259,1.8,1.8,0,0,0,.931-.479.422.422,0,0,1,.6-.009A1.864,1.864,0,0,0,16,6.612a3.234,3.234,0,0,1,1.937,1.259,6.515,6.515,0,0,1,1.046,3.959,9.516,9.516,0,0,0,.716,4.023A5.557,5.557,0,0,0,20.777,17.4.187.187,0,0,1,20.622,17.709Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1249 32)",
    fill: "#d60000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.dfde62891992edf0d8e00b46f55da40b.svg";
export { ForwardRef as ReactComponent };